import { network } from 'services/network';

export const saveCustomCluster = (params) => {
    return network.post('api/bo/saveCustomCluster', params).then((response) => {
        return response.data;
    });
};
